import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(1)
    }
}))